// BomReducer.js — Manufacturer Module, Phase 3, Step 6.
// Backs Recipe (BOM) screens only. Wired into rootReducer.js as `bom`.

const initialState = {
  recipes: [],
  selectedRecipe: null,
  // SO shortage -> Production Order modal: active recipes/outputs that
  // can produce a given Finish Good, cached by product_id.
  recipesByProduct: {},
  loading: false,
  actionLoading: false,
  error: null
};

const BomReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'FETCH_RECIPES_REQUEST':
      return { ...state, loading: true, error: null };
    case 'FETCH_RECIPES_SUCCESS':
      return { ...state, loading: false, recipes: action.payload, error: null };
    case 'FETCH_RECIPES_FAILURE':
      return { ...state, loading: false, error: action.payload };

    case 'GET_RECIPE_REQUEST':
      return { ...state, actionLoading: true, error: null };
    case 'GET_RECIPE_SUCCESS':
      return { ...state, actionLoading: false, selectedRecipe: action.payload, error: null };
    case 'GET_RECIPE_FAILURE':
      return { ...state, actionLoading: false, error: action.payload };

    case 'CREATE_RECIPE_REQUEST':
    case 'UPDATE_RECIPE_REQUEST':
    case 'DELETE_RECIPE_REQUEST':
      return { ...state, actionLoading: true, error: null };

    case 'CREATE_RECIPE_SUCCESS':
      return { ...state, actionLoading: false };
    case 'UPDATE_RECIPE_SUCCESS':
      return { ...state, actionLoading: false };
    case 'DELETE_RECIPE_SUCCESS':
      return {
        ...state,
        actionLoading: false,
        recipes: state.recipes.filter((r) => r.id !== action.payload)
      };

    case 'CREATE_RECIPE_FAILURE':
    case 'UPDATE_RECIPE_FAILURE':
    case 'DELETE_RECIPE_FAILURE':
      return { ...state, actionLoading: false, error: action.payload };

    case 'CLEAR_SELECTED_RECIPE':
      return { ...state, selectedRecipe: null };

    case 'FETCH_RECIPES_BY_PRODUCT_SUCCESS':
      return {
        ...state,
        recipesByProduct: { ...state.recipesByProduct, [action.payload.productId]: action.payload.outputs }
      };

    default:
      return state;
  }
};

export default BomReducer;